import { type FC, type PropsWithChildren, createContext, useContext, useState } from 'react';

export interface ProviderKitchenSinkProps extends PropsWithChildren {
}

interface KitchenSinkContextValue {
  attendeeCategoryId: string
  setAttendeeCategoryId: (attendeeCategoryId: string) => void
}

const KitchenSinkContext = createContext<KitchenSinkContextValue>({
    attendeeCategoryId: '',
    setAttendeeCategoryId: (attendeeCategoryId: string) => {},
});

export const ProviderKitchenSink: FC<ProviderKitchenSinkProps> = ({
  ...props
}) => {
  const [attendeeCategoryId, setAttendeeCategoryId] = useState<string>('');

  return (
    <KitchenSinkContext.Provider
      value={{
        attendeeCategoryId,
        setAttendeeCategoryId
      }}
      {...props}
    />
  );
};

export function useKitchenSink() {
  const { attendeeCategoryId, setAttendeeCategoryId } = useContext(KitchenSinkContext) as Required<KitchenSinkContextValue>;

  return {
    attendeeCategoryId,
    setAttendeeCategoryId,
  };
}
